module.exports = __webpack_public_path__ + "media/mouseOverBox.ce778506.mp3";